import React from 'react'

import { DatePickerComponent, Inject, MaskedDateTime } from '@syncfusion/ej2-react-calendars'

import { getMixedProps } from './blockPublic'
import { nullDate } from '../../../utility'
import { useEventHandler, useInstData } from 'tyan/public/hooks'

const FormDate = ({ config: { field, onChange, initValues, /* changedValues,  */defaultStyle, that } }) => {
	const { me } = useInstData()
	const { value: currentValue, name } = field
	const value = Tyan.sysMode === 'sample' && typeof currentvalue === 'string'
		? Tyan.Date.getDate(currentValue)
		: currentValue && currentValue !== nullDate && Tyan.Date.getDateLocal(currentValue) || null
	// const d = currentValue && currentValue !== nullDate && new Date(currentValue) || null
	// const value = d && new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())
	const handleChange = useEventHandler(({ value: inputValue }) => {
		const newValue = inputValue ? Tyan.Date.getDateUtcValue(inputValue) : nullDate
		onChange({ name, newValue: newValue, type: 'date' })
	})

	let { props: { disabled, minDate, min, maxDate, max, clearable, ...props } } = getMixedProps('_date', [defaultStyle, field])
	min = min || minDate
	max = max || maxDate
	min && (props.min = new Date(min.getFullYear(), min.getMonth(), min.getDate()))
	max && (props.max = new Date(max.getFullYear(), max.getMonth(), max.getDate()))

	return <DatePickerComponent {...props}
		openOnFocus
		format='yyyy/MM/dd' enableMask maskPlaceholder={{ year: 'yyyy', month: 'mm', day: 'dd' }}
		enabled={!disabled} showClearButton={clearable}
		value={value} change={handleChange} /* focus={handleFocus} blur={handleBlur} */ >
		<Inject services={[MaskedDateTime]} />
	</DatePickerComponent>
}

const renderDate = config => {
	const { key } = config.field || {}
	return <FormDate key={key} config={config} />
}

export default renderDate